<template>
  <div id="about-us">
    <div class="about-us">
      <b-container fluid class="section">
        <h1 class="page-title">{{ this.page.title }}</h1>
        <b-row>
          <b-col md="8" sm="12">
            <p v-html="page.about_us_text"></p>
          </b-col>
          <b-col
            md="4"
            sm="12"
            class="d-flex justify-content-end align-items-center"
          >
            <img
              class="img-fluid"
              alt="About us logo"
              :src="page.logo.download_url"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="contacts">
      <contact
        :phone="this.page.phone_number"
        :email="this.page.email"
        :address="this.page.address"
      ></contact>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Contact.vue";

export default {
  name: "AboutUsPage",
  props: ["page"],
  components: {
    Contact,
  },
  data: function () {
    return {};
  },
};
</script>

<style lang="scss">
#about-us {
  background-color: white !important;
}

.about-us {
  background-color: #eeeeee;
  border-bottom: 1px dashed $secondary-color !important;
}

.page-title {
  margin-bottom: 1.2em;
  margin-top: 2em;
}
</style>
